/**
 * 基于Vue的全局事件中心
 *  Created by long.wang on 2019/5/30
 */
import Vue from 'vue'
export default new Vue()
